export default __webpack_public_path__ + "static/media/free_1-1_tutorial_bg.9dce456b.jpg";